export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;

export const KEY = 'a7f29901-0067-489c-a888-117d65247d03';

export const MODAL_CLOSE_SEC = 2.5;
